<template>
  <div
    v-click-outside="close"
    class="cart__search__input-container"
  >
    <input
      id="client-search"
      v-model="searchInput"
      type="search"
      autocomplete="new-password"
      class="cart__search__input cart__search__input--with-icon"
      placeholder="Hae Y-tunnuksella tai asiakasnumerolla"
      @keyup="handleKeyUp"
      @keydown.enter.prevent="search()"
    >
    <ul
      v-if="results.length > 0 && isOpen"
      class="cart__search__results"
    >
      <li
        v-for="result in results"
        :key="result.billing.customer_code"
        class="cart__search__result"
        tabindex="0"
        @click="select(result)"
      >
        <span class="cart__search__result-main">{{ result.billing.company }}</span>
        <span class="cart__search__result-detail"> {{ result.billing.company_id }} ({{ result.billing.customer_code }})</span>
      </li>
    </ul>
    <div
      v-else-if="isOpen && !loading"
      class="cart__search__results"
    >
      <div class="cart__search__no-results">
        Ei tuloksia
      </div>
    </div>
    <div
      v-else-if="isOpen && loading"
      class="cart__search__results"
    >
      <div class="cart__search__no-results">
        Ladataan...
      </div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios';
    import ClickOutside from 'vue-click-outside';
    import _ from 'lodash';

    export default {
        directives: {
            ClickOutside,
        },
        props: {
            nonce: {
                type: String,
                default: '',
            },
        },
        data : function () {
            return {
                searchInput: '',
                results: [],
                selectedCustomer: null,
                isOpen: false,
                loading: false,
            };
        },
        methods: {
            select(customer) {
                this.selectedCustomer = customer;
                this.$emit('change', this.selectedCustomer);
                this.isOpen = false;
            },

            handleKeyUp() {
                if (event.key === 'Enter') {
                    this.search();
                } else {
                    this.dSearch();
                }
            },

            search() {

                if (this.loading) {
                    return false; //Let's not do multiple searches at same time...
                }

                this.isOpen = true;
                this.results = [];
                this.loading = true;

                if (this.searchInput == '') {
                    this.loading = false;
                    return false;
                }

                let config = {
                    headers: {
                        'X-WP-Nonce': this.nonce,
                    },
                }

                axios.get('/wp-json/modeo/v2/customers?orderby=name&page=1&per_page=10&search=' + this.searchInput, config)
                .then(response => {
                    this.loading = false;
                    this.results = response.data;
                });
            },

            dSearch: _.debounce(function() {
                this.search();
            }, 1000),

            open() {
                this.isOpen = true;
            },

            close() {
                this.isOpen = false;
            },

        },
    }
</script>
